module.exports = __webpack_public_path__ + "img/phone.6974c112.svg";